import React from 'react';
import { Container, Row } from 'react-bootstrap';
import HelpInfo from './HelpInfo';
import Header from './Header';
import Tutorial from './Tutorial';
// import News from './News';

const HelpDesk = () => {
  return (
    <Container fluid>
      <Row>
        <Header />
        <HelpInfo />
        <Tutorial />
      </Row>
    </Container>
  );
};

export default HelpDesk;
